import { render, staticRenderFns } from "./PersonUserFormular.vue?vue&type=template&id=f9006712"
import script from "./PersonUserFormular.vue?vue&type=script&lang=js"
export * from "./PersonUserFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Errormessage: require('/Users/stefan/Dropbox/Stefan/gitrepos/p1ng/gnoema/frontend/components/Errormessage.vue').default,TooltipInformation: require('/Users/stefan/Dropbox/Stefan/gitrepos/p1ng/gnoema/frontend/components/TooltipInformation.vue').default})
